(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('MedicationSearch', MedicationSearch);

    MedicationSearch.$inject = ['$resource'];

    function MedicationSearch($resource) {
        var resourceUrl =  'api/_search/medications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
